import FormProperty from "./FormProperty/FormProperty";
import GenerateQuestion from "../GenereteQuestion/GeneratQuestion";
import { Container, Row, Col } from "react-bootstrap";

const FormImovel = () => {

  return (
    <Container className="custom-margin-left mt-5 p-0 mb-2" fluid>
      <Row className="d-flex align-items-start flex-wrap">
      <Col
          xs={12}
          lg={3}
          className="d-flex justify-content-center align-items-center p-0 px-4 px-md-0"
        >
          <GenerateQuestion
            header="Dados do imóvel"
            subheader="Por favor, insira os dados do imóvel corretamente nos campos ao lado. O valor do financiamento, limite de parcela e entrada é liberado automaticamente."
          />
        </Col>
        <Col xs={1} sm={1} md={1} lg={1} className="d-none d-md-block"></Col>
        <Col className="mx-3 mx-md-0">
          <FormProperty />
        </Col>
      </Row>
    </Container>
  );
};

export default FormImovel;
